<!--
frontend-author:udayasankar ,
backend-author: ,
page-name :Reports.vue,
page-description :Index page for Reports ,
started at : 15-Apr-2019,
edited at :16-Apr-2019.
-->
<template>
  <div style="margin-top:-10px !important">
    <div class="nav-container pad-nav">
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col md="6" lg="6" sm="6" class="px-0">
          <span class="fw-semi-bold index-heading pl-0" style="position:relative;top:2px;">Reports</span>
        </b-col>
      </b-row>
      <div style="margin-right:-10px;margin-left:-10px">
        <b-row v-if="RoutePermission(false,'','reports','reports','salesreport')">
          <b-col xl="4" lg="4" md="12" sm="12" xs="12">
            <b-nav vertical class="side-nav-content">
              <h5 class="invoice mt-4 pl-3 mb-1">
                <i class="la la-shopping-cart la-lg"></i>
                Sales
              </h5>
              <b-nav-item
                :to="{name:'SalesCustomer',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item active"
                active
              >
                <span class="fa fa-angle-right pr-3"></span>Sales by Customer
              </b-nav-item>
              <b-nav-item
                :to="{name:'SalesItem',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Sales
                by Product
              </b-nav-item>
              <b-nav-item
                :to="{name:'SalesPerson',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Sales by Salesperson
              </b-nav-item>
            </b-nav>
          </b-col>
          <b-col xl="4" lg="4" md="12" sm="12" xs="12">
            <b-nav vertical class="side-nav-content">
              <h5 class="invoice mt-4 pl-3 mb-1">
                <i class="la la-calculator la-lg"></i>
                Receivable
              </h5>
              <b-nav-item
                :to="{name:'CustomerBalancesReport',query:{report_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Customer Balances
              </b-nav-item>
              <b-nav-item
                :to="{name:'EstimateReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Quotation Details
              </b-nav-item>
              <b-nav-item
                :to="{name:'InvoiceReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Invoice Details
              </b-nav-item>
              <b-nav-item
                :to="{name:'RetainerInvoiceDetailsReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Customer Deposit Details
              </b-nav-item>
              <b-nav-item
                :to="{name:'AgingDetailsReport',query:{filter_by : '',interval_range:15,number_of_columns:4}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Aging Details
              </b-nav-item>
              <b-nav-item
                :to="{name:'BankChargesReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Bank Charges
              </b-nav-item>
            </b-nav>
          </b-col>
          <b-col xl="4" lg="4" md="12" sm="12" xs="12">
            <b-nav vertical class="side-nav-content">
              <h5 class="invoice mt-4 pl-3 mb-1">
                <i class="la la-credit-card la-lg"></i>
                Payment Received
              </h5>
              <b-nav-item
                :to="{name:'PaymentsReceivedReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>
                Payments Received
              </b-nav-item>
              <b-nav-item
                :to="{name:'RefundHistoryReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Refund History
              </b-nav-item>
              <b-nav-item
                :to="{name:'PaymentReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Invoice Payment
                Details
              </b-nav-item>
              <b-nav-item
                :to="{name:'CreditNoteDetailsReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Credit Note Details
              </b-nav-item>
              <b-nav-item
                :to="{name:'TDSDetailsReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item"
              >
                <span class="fa fa-angle-right pr-3"></span>Withholding tax
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            xl="4"
            lg="4"
            md="12"
            sm="12"
            xs="12"
            v-if="RoutePermission(false,'','reports','reports','salesreport')"
          >
            <b-nav vertical class="side-nav-content">
              <h5 class="invoice mt-4 pl-3 mb-1">
                <i class="la la-retweet la-lg"></i>
                Recurring
              </h5>
              <b-nav-item
                :to="{name:'RecurringInvoiceReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item active"
                active
              >
                <span class="fa fa-angle-right pr-3"></span>Recurring Invoice
              </b-nav-item>
            </b-nav>
          </b-col>
          <b-col
            xl="4"
            lg="4"
            md="12"
            sm="12"
            xs="12"
            v-if="RoutePermission(false,'','reports','reports','amccontractreport')"
          >
            <b-nav vertical class="side-nav-content">
              <h5 class="invoice mt-4 pl-3 mb-1">
                <!-- <img src="@/assets/icons/recurring.png" class="mb-1" style="width:15px" /> -->
                <i class="la la-sitemap la-lg"></i>
                AMC Contract
              </h5>
              <b-nav-item
                :to="{name:'AmcContractReport',query:{from_date:from_date,to_date:to_date}}"
                class="sidenav-item active"
                active
              >
                <span class="fa fa-angle-right pr-3"></span>AMC Contracts
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
        <b-row v-if="RoutePermission(false,'','reports','reports','salesreport')">
          <b-col xl="4" lg="4" md="12" sm="12" xs="12">
            <b-nav vertical class="side-nav-content">
              <h5 class="invoice mt-4 pl-3 mb-1">
                <i class="la la-certificate la-lg"></i>
                Taxes
              </h5>
              <b-nav-item
                :to="{name:'TaxSummary',query:{from_date:from_date,to_date:to_date,report_by:1}}"
                class="sidenav-item active"
                active
              >
                <span class="fa fa-angle-right pr-3"></span>Tax Summary
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>
      </div>
      <!-- Sidenav for Invoice Reports -->
    </div>
  </div>
</template>
<!--Script for Invoice Reports-->
<script>
import { formatDate } from "@/mixins/formatDate";
import moment from "moment";
export default {
  name: "PayItems",
  mixins: [formatDate],
  data() {
    return {
      from_date: this.formatDate(moment().startOf("month")),
      to_date: this.formatDate(moment().endOf("month")),
      user_invtry_date: this.formatDate(moment().endOf("month"))
    };
  }
};
</script>
<style scoped>
.page-title {
  margin: 0 0;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.pad-nav {
  padding-left: 0px;
}
.glyphicon {
  vertical-align: top;
  padding-right: 5px;
}
.page-title {
  padding-left: 14px;
}
.ul-pad {
  padding-bottom: 12px;
}
</style>